/**
 * Helper: after creating a customer, commit the staged document uploads.
 * stagedDocs shape: { customer: {photo:File, cnic_front:File...}, guarantor1: {...}, guarantor2: {...} }
 */
import { api } from "./api";

export async function commitStagedDocs(customerId, stagedDocs) {
  if (!customerId || !stagedDocs) return;
  const upload = async (endpoint, file) => {
    const fd = new FormData();
    fd.append("file", file);
    await api.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } });
  };

  const tasks = [];
  for (const [slot, file] of Object.entries(stagedDocs.customer || {})) {
    if (file) tasks.push(upload(`/customers/${customerId}/documents/${slot}`, file));
  }
  for (const [slot, file] of Object.entries(stagedDocs.guarantor1 || {})) {
    if (file) tasks.push(upload(`/customers/${customerId}/guarantor/1/documents/${slot}`, file));
  }
  for (const [slot, file] of Object.entries(stagedDocs.guarantor2 || {})) {
    if (file) tasks.push(upload(`/customers/${customerId}/guarantor/2/documents/${slot}`, file));
  }
  // Upload in parallel — small files, single round-trip otherwise too slow on mobile.
  const results = await Promise.allSettled(tasks);
  const failed = results.filter((r) => r.status === "rejected");
  return { ok: results.length - failed.length, failed: failed.length };
}

export const emptyStagedDocs = () => ({
  customer: {},
  guarantor1: {},
  guarantor2: {},
});
